import { IOptions } from '../../../common/common.types'
import { IRootState } from '../../../store'

export const getActionsList = (state: IRootState): IOptions => state.timeline.actionsList
